// libraries
import clsx from 'clsx'

// components
import Video, { VideoProps } from '/react4xp/components/Video'
import Section from '/react4xp/components/Section'

// types
interface VideoBlockProps {
    className?: string
    isAnimated?: boolean
    video?: VideoProps
    caption?: string
}

// css
import './index.scss'

export default function VideoBlock({
    className,
    isAnimated,
    video,
    caption
}: VideoBlockProps) {
    return (
        <Section>
			<div
                className='container'
                data-stagger-up={isAnimated ? 'true' : 'false'}
            >
                <div className={clsx(
                    'video-block-component',
                    className
                )}>
                    
                    <Video
                        url={video?.url || ''}
                        type={video?.type || 'default'}
                        aspectRatio='16:9'
                        image={video?.image}
                    />

                    {caption && (
                        <p className='video-block-component__caption body-small'>
                            {caption}
                        </p>
                    )}

                </div>
            </div>
        </Section>
    )
}